/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_CopiedInputs */



/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Developer_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_copied = /** @type {((inputs?: Developer_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copié dans le presse-papiers")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiado al portapapeles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiado para a área de transferência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copiato negli appunti")
	return /** @type {LocalizedString} */ ("Copied to clipboard")
});